import Vue from 'vue'
import VueRouter from 'vue-router'
import firebase from "../plugins/firebase";

import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Reset from '../views/Reset.vue'
import Auth from '../views/Auth.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: "*",
    redirect: "/Login",
  },
  {
    path: '/Auth',
    name: 'Auth',
    component: Auth,
    children: [
      {
        path: '/Reset',
        name: 'Reset',
        component: Reset
      },
      {
        path: '/Login',
        name: 'Login',
        component: Login
      },

    ]
  },
  {
    path: '/Home',
    name: 'Home',
    component: Home,
    meta: {
      lock: true,
    }
  }
]

const router = new VueRouter({
  duplicateNavigationPolicy: 'ignore',
  routes,
});
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 1);
  let usuario = firebase.auth().currentUser;
  let key = to.matched.some(record => record.meta.lock);
  if (!usuario && key) {
    next("/Auth/Welcome");
  } else if (usuario && !key) {
    next("/Home");
  } else {
    next();
  }
});
export default router;